import {NamedStyles, StyleHelper} from '../../../../shared/hooks/styles';
import {DeviceSize} from '../../../../shared/theme/helpers';

export default ({theme, isDesktop, mediaOnly}: StyleHelper): NamedStyles<any> => ({
  accordionContent: {
    paddingTop: 0,
    paddingHorizontal: isDesktop ? 44 : 0,
  },
  answerText: {
    ...mediaOnly(DeviceSize.desktop, theme.fonts.h6Light, theme.fonts.additionalText),
    paddingBottom: isDesktop ? 35 : 18,
  },
  answerTextWithIcon: {
    paddingRight: isDesktop ? 20 : 0,
    paddingLeft: isDesktop ? 12 : 16,
  },
  answerStack: {
    display: 'flex',
    flexDirection: isDesktop ? 'row' : 'column',
    flexWrap: isDesktop ? 'wrap' : 'nowrap',
  },
  answerContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    width: isDesktop ? '50%' : '100%',
  },
  answerIcon: {
    paddingTop: 6,
    color: theme.supportService.questionAccordionCheckMarkColor,
  },
});
